import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import FacilityFrame from './facilityFrame';
import { ROOM_PRICE, roomBlocker } from '../utils/services';

// The tavern: the only place in town the party can sleep. Out in the dungeon
// they camp for nothing; here a full night costs the price of the beds.
class Tavern extends Component {

  handleKeydown = (e) => {
    if (e.key.toLowerCase() === 'r') this.props.context.takeRoom();
  }

  // What a night would do for this character
  describe(character) {
    if (character.condition === 'dead') return 'beyond the landlord\'s help';
    const hp = character.maxHp - character.hp;
    const sp = character.maxSp - character.sp;
    if (!hp && !sp) return 'well rested already';
    return [hp && `${hp} HP`, sp && `${sp} SP`].filter(Boolean).join(' and ') + ' to sleep off';
  }

  render() {
    const { facility, party, gold, takeRoom } = this.props.context;
    if (facility !== 'tavern') return null;
    const blocker = roomBlocker(gold);
    const weary = party.some((c) => c.condition !== 'dead' && (c.hp < c.maxHp || c.sp < c.maxSp));

    return (
      <FacilityFrame
        title="The Tavern"
        quote='"Beds upstairs, ale down here, and no questions either way."'
        hint="Press R or click the bell · a night restores everyone who can still be woken"
        onKey={this.handleKeydown}
      >
        <div className="training-list">
          {party.map((c) => (
            <div key={c.id} className={classNames('training-row', { ready: c.condition !== 'dead' })}>
              <div className="training-who">
                <div className="training-name">
                  {c.name} <span className="sheet-muted">{c.className} {c.level}</span>
                </div>
                <div className="sheet-muted">
                  {c.hp}/{c.maxHp} HP{c.maxSp > 0 && ` · ${c.sp}/${c.maxSp} SP`} · {this.describe(c)}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="tavern-bar">
          <div className="sheet-muted">
            {weary ? 'The stairs to the rooms are behind the bar.' : 'Nobody here needs a bed, but the beds are there.'}
          </div>
          <button
            className={classNames('menu-button', { disabled: !!blocker })}
            onClick={takeRoom}
          >
            TAKE ROOMS (R) · {ROOM_PRICE}g
          </button>
        </div>
      </FacilityFrame>
    );
  }
}

export default withContext(Tavern);
